import React from 'react'
import PropTypes from 'prop-types';
import moment from 'moment'
import { Button } from 'react-bootstrap'
import classnames from 'classnames'
import { ListItem } from '~/views'
import style from './style.css'

export default class RelationshipItem extends React.Component {

  static REMOVE_ITEM = 'remove';

  static GO_TO_ITEM = 'goToItem';

  static GO_TO_ITEM_DETAILS = 'goToItemDetails'

  static propTypes = {
    item : PropTypes.object.isRequired,
    onEvent : PropTypes.func,
    selected : PropTypes.bool
  };

  onEvent( event ) {
    if ( this.props.onEvent ) { 
      this.props.onEvent( event, this.props.item );
    }
  }

  noOp() {}

  render() {
    const { item : relationshipItem, showDelete } = this.props;
    const { disabled } = relationshipItem

    let subtitle = (
      <div>
        <div>
          <i className={classnames( 'fa fa-clock-o', style.subtitleIcon )} /> 
          {' '}
          {moment( relationshipItem.lastModified ).fromNow()}
        </div>
        <div>
          <i className={classnames( 'fa fa-microchip', style.subtitleIcon )} />
          {relationshipItem && relationshipItem.id}
        </div>
      </div>
    )
    if ( relationshipItem.networkAliases ) {
      const network = Object.keys( relationshipItem.networkAliases )[0]
      const aliasKey = Object.keys( relationshipItem.networkAliases[network] )[0]
      const alias = relationshipItem.networkAliases[network][aliasKey]
      subtitle = (
        <div>
          <div>
            <i className={classnames( 'fa fa-clock-o', style.subtitleIcon )} />
            {moment( relationshipItem.lastModified ).fromNow()}
          </div>
          <div>
            <i className={classnames( 'fa fa-wifi', style.subtitleIcon )} />
            {`${network} | ${aliasKey} : ${alias}`}
          </div>
        </div>
      )
    }
    return (
      <ListItem className={classnames( style.relationshipItem, disabled ? style.disabled : '' )} 
        onEvent={disabled ? this.noOp : this.props.onEvent}
        item={relationshipItem}
        selected={this.props.selected}
        title={relationshipItem.name}
        subtitle={subtitle}
        leftView={this.renderLeft( relationshipItem )}
        rightView={this.renderRight( relationshipItem, showDelete )}
        titleClass={style.itemTitle}
        subtitleClass={style.itemSubtitle} />
    )
  }

  onGoTo = () => {
    this.onEvent( RelationshipItem.GO_TO_ITEM )
  }

  onDetails = () => {
    this.onEvent( RelationshipItem.GO_TO_ITEM_DETAILS )
  }

  renderLeft() {
    return null;
  }

  renderRight( relationshipItem, showDelete ) {
    const { disabled } = relationshipItem
    return (
      <div>
        {showDelete && (
          <Button
            bsStyle="link"
            className={style.itemButton}
            disabled={disabled}
            title="remove device from list"
            onClick={() => { this.onEvent( RelationshipItem.REMOVE_ITEM ) }}> 
            <i className="fa fa-times-circle" />
          </Button>
        )}
        <Button
          title="go to device details"
          disabled={disabled}
          bsStyle="link"
          className={style.itemButton}
          onClick={this.onDetails}>
          <i className="fa fa-info-circle" />
        </Button>
        <Button
          title="go to device data"
          onClick={this.onGoTo}
          bsStyle="link"
          className={style.itemButton}
          disabled={disabled}>
          <i className="fa fa-arrow-right" />
        </Button>
      </div>
    )
  }

}
